import Vue from 'vue'
import router from './router'
import App from './App.vue'
import 'vant/lib/index.less'
import store from './store/index.js'

import { Switch, SwipeCell, Picker, Popup, DatetimePicker, Uploader, CellGroup, Loading, Form, Field, Button, Col, Row, Image as VanImage, NavBar, List, Cell, Tag, Tab, Tabs, Icon, ActionSheet, Divider, Tabbar, TabbarItem, RadioGroup, Radio, Calendar, Checkbox, Overlay } from 'vant'

Vue.config.productionTip = false
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(VanImage)
Vue.use(NavBar)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(List)
Vue.use(Tag)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(ActionSheet)
Vue.use(Divider)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Calendar)
Vue.use(Checkbox)
Vue.use(Overlay)
Vue.use(Loading);
Vue.use(Uploader);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(SwipeCell);
Vue.use(Switch);

import VueSignaturePad from "vue-signature-pad";
Vue.use(VueSignaturePad);
import axios from "axios";
axios.defaults.baseURL =
  process.env.NODE_ENV === "development" ? "" : "https://api.smze.cn";

Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')